import React, { createContext, useState, useContext, useEffect } from 'react'
import { getUserIdFromUrl } from '../../helpers/user-id'

type AuthContextType = {
  userId: string | null
}

export const AuthContext = createContext<AuthContextType>({
  userId: null,
})

export const AuthProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [userId, setUserId] = useState<string | null>(null)

  useEffect(() => {
    setUserId(getUserIdFromUrl())
  }, [])

  return (
    <AuthContext.Provider value={{ userId }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider')
  }
  return context
}
